<template>
  <div class="space-y-1">
    <p class="font-heiti">A4 信息安全</p>
    <p>{{info.p_2_1_d_1}}</p>
    <p class="text-bold pt-2">——A41 网络安全</p>
    <P>{{info.p_2_1_d_2}}</P>
    <p>{{info.p_2_1_d_3}}</p>
    <p class="text-bold pt-2">——A42 数据安全</p>
    <p>{{info.p_2_1_d_4}}</p>
    <p>{{info.p_2_1_d_5}}</p>
    <div class="pt-3 space-y-2">
      <div class="text-center font-heiti">表 2-1-2 数字化基础维度的采集项层级评测得分</div>
      <div class="grid grid-cols-5 w-full text-center items-center border-t border-solid border-black">
        <div class="col-span-1 border-b border-solid border-black py-2 font-heiti">二级指标</div>
        <div class="col-span-1 border-b border-solid border-black py-2 font-heiti">采集项</div>
        <div class="col-span-3 border-b border-solid border-black py-2 font-heiti">评测得分情况</div>
        <div class="col-span-1 border-b border-solid border-black h-full flex justify-center items-center py-2 font-heiti">A1 设备系统</div>
        <div class="col-span-4 grid grid-cols-4 border-b border-solid border-black py-2">
          <div class="col-span-1 h-full flex justify-center items-center py-1">A11 网络建设</div>
          <rate-bar class="col-span-3 py-1" :yellow="{val: info.answerArr[0].score * 10, label: info.answerArr[0].score * 1 || 0, rate: (info.answerArr[0].score / 8 * 100).toFixed(3) * 1 + '%'}" :blue="{val: 80, label : '8'}" />
          <div class="col-span-1 h-full flex justify-center items-center py-1">A12 设备数字化</div>
          <rate-bar class="col-span-3 py-1" :yellow="{val: info.answerArr[1].score * 10, label: info.answerArr[1].score * 1 || 0, rate: (info.answerArr[1].score / 6 * 100).toFixed(3) * 1 + '%'}" :blue="{val: 60, label : '6'}" />
          <div class="col-span-1 h-full flex justify-center items-center py-1">A13 设备联网</div>
          <rate-bar class="col-span-3 py-1" :yellow="{val: info.answerArr[2].score * 10, label: info.answerArr[2].score * 1 || 0, rate: (info.answerArr[2].score / 6 * 100).toFixed(3) * 1 + '%'}" :blue="{val: 60, label : '6'}" />
        </div>
        <div class="col-span-1 border-b border-solid border-black h-full flex justify-center items-center py-2 font-heiti">A2 数据采集</div>
        <div class="col-span-1 border-b border-solid border-black h-full flex justify-center items-center py-2">A21 数据采集</div>
        <rate-bar class="col-span-3 border-b border-solid border-black py-2" :yellow="{val: info.answerArr[3].score * 10, label: info.answerArr[3].score * 1 || 0, rate: (info.answerArr[3].score / 10 * 100).toFixed(3) * 1 + '%'}" :blue="{val: 100, label : '10'}" />
        <div class="col-span-1 border-b border-solid border-black h-full flex justify-center items-center py-2 font-heiti">A3 信息系统</div>
        <div class="col-span-1 border-b border-solid border-black h-full flex justify-center items-center py-2">A31 信息系统</div>
        <rate-bar class="col-span-3 border-b border-solid border-black py-2" :yellow="{val: info.answerArr[4].score * 10, label: info.answerArr[4].score * 1 || 0, rate: (info.answerArr[4].score / 10 * 100).toFixed(3) * 1 + '%'}" :blue="{val: 100, label : '10'}" />
        <div class="col-span-1 border-b border-solid border-black h-full flex justify-center items-center py-2 font-heiti">A4 信息安全</div>
        <div class="col-span-4 grid grid-cols-4 border-b border-solid border-black py-2">
          <div class="col-span-1 h-full flex justify-center items-center py-1">A41 网络安全</div>
          <rate-bar class="col-span-3 py-1" :yellow="{val: info.answerArr[5].score * 10, label: info.answerArr[5].score * 1 || 0, rate: (info.answerArr[5].score / 5 * 100).toFixed(3) * 1 + '%'}" :blue="{val: 50, label : '5'}" />
          <div class="col-span-1 h-full flex justify-center items-center py-1">A42 数据安全</div>
          <rate-bar class="col-span-3 py-1" :yellow="{val: info.answerArr[6].score * 10, label: info.answerArr[6].score * 1 || 0, rate: (info.answerArr[6].score / 5 * 100).toFixed(3) * 1 + '%'}" :blue="{val: 50, label : '5'}" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RateBar from '@/components/RateBar'

// 数字化基础维度2
export default {
  components: { RateBar },
  props: ['info']
}
</script>
